import { AnalyticsClient, AnalyticsEvent } from "@App/utils/analytics/interfaces";

export class AnalyticsMux implements AnalyticsClient {
  constructor(private readonly clients: AnalyticsClient[]) {}
  capture(evt: AnalyticsEvent) {
    this.clients.forEach((c) => c.capture(evt));
  }
}
